export const navbarAnimation = {
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: -100,
  },
};

export const navbarTransition = {
  delay: 1,
  duration: 2,
};

export const logoAnimation = {
  in: {
    opacity: 1,
    rotate: 0,
  },
  out: {
    opacity: 0,
    rotate: 360,
  },
};

export const logoTransition = {
  delay: 1,
  duration: 2,
};
